module.exports = __webpack_public_path__ + "img/ez-theme-switcher-ic-register.fbd4e2f5.png";